import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import oIconLibrary from 'utils/iconLibrary';
import { selectSubEventsByMainEventLookupId } from 'components/EventRegistration/redux/selectors';

/**
 * Displays sub events in the cart for the given main event.
 */
const SelectedEventsList = ({ sMainEventLookupId = '' }) => {
  const aSubEventCartItems = useSelector(
    selectSubEventsByMainEventLookupId(sMainEventLookupId)
  );
  return aSubEventCartItems.length > 0 ? (
    <div className='multiLevelEventDetails__eventsSelected'>
      <div>
        <h3 className='multiLevelEventDetails__eventsSelectedTitle t-paragraph--medium'>
          Events Selected
        </h3>
        <ul className='multiLevelEventDetails__eventsSelectedList'>
          {aSubEventCartItems.map((oSubEventCartItem) => {
            const oSubEvent = oSubEventCartItem.oDetails.oEvent;
            return (
              <li
                key={oSubEvent.LOOKUPID}
                className='multiLevelEventDetails__eventsSelectedItem t-paragraph--small'
              >
                <FontAwesomeIcon icon={oIconLibrary.fontAwesome.calendarStar} />
                {oSubEvent.TITLE}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  ) : null;
};

SelectedEventsList.propTypes = {
  sMainEventLookupId: PropTypes.string,
};

SelectedEventsList.defaultProps = {
  sMainEventLookupId: '',
};

export default SelectedEventsList;
